import { API_ENDPOINT } from '@Env/variables';
import { createAxiosInstance } from './axios';
import {
  Assigned,
  AssignedRecordResponse,
  AssignedRecordsResponse,
  FeatDescrip,
  FeatItem,
  Product,
  Release,
} from '@Models/types';

export const ahaAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, API_ENDPOINT);

  return {
    getReleases: async (ref_pref: string) => {
      const res = await axios.post<Release[]>('/api/getReleases', {
        reference_prefix: ref_pref,
      });
      return res.data;
    },

    getProd: async () => {
      const res = await axios.get<{ Product: Product[] }>('/api/getProd');
      return res.data.Product;
    },

    getFavProd: async () => {
      const res = await axios.get<{ FavProd: Product[] }>('/api/getFavProd');
      return res.data.FavProd;
    },

    saveFavProd: async (favoriteProductIds: Product[]) => {
      const res = await axios.post('/api/setFavProd', {
        favoriteProductIds,
      });
      return res.data.favorites;
    },

    getFeatList: async (ref_pref: string) => {
      const res = await axios.post<FeatItem[]>('/api/getFeatList', {
        reference_prefix: ref_pref,
      });
      return res.data;
    },

    getFeatDetails: async (ref_num: string) => {
      const res = await axios.post<FeatDescrip[]>('/api/getFeatDetails', {
        reference_num: ref_num,
      });
      return res.data;
    },

    getAssignedRecords: async () => {
      let assigned: Assigned[] = [];
      const email = localStorage.getItem('email') || '';
      const res = await axios.get<AssignedRecordsResponse>(
        `/api/getAssignedRecords?email=${encodeURIComponent(email)}`
      );
      assigned = res.data.assigned.map((record: AssignedRecordResponse) => ({
        reference_num: record.reference_num,
        name: record.name,
        status: record.status,
        record_type: record.record_type,
        id: record.id,
        workflow_status: record.workflow_status
          ? {
              id: record.workflow_status.id,
              name: record.workflow_status.name,
              position: record.workflow_status.position,
              complete: record.workflow_status.complete,
              color: record.workflow_status.color,
            }
          : undefined,
        due_date: record.due_date || 'No due date set',
        current_task_user: record.current_task_user,
        description: record.description || 'No description available',
        priority: record.priority || 'No priority set',
        url: record.url,
      }));

      return assigned;
    },
  };
};
